import { Skeleton } from 'antd';

// Custom data source to show skeletons inside table rows
const skeletonData = Array.from({ length: 10 }, (_, index) => ({
  key: index,
  index: <Skeleton active title={false} paragraph={{ rows: 1, width: "20px" }} />,
  firstName: <Skeleton active title={false} paragraph={{ rows: 1, width: "80px" }} />,
  lastName: <Skeleton active title={false} paragraph={{ rows: 1, width: "80px" }} />,
  email: <Skeleton active title={false} paragraph={{ rows: 1, width: "150px" }} />,
  browseImage: <Skeleton active title={false} paragraph={{ rows: 1, width: "60px" }} />,
  message: <Skeleton active title={false} paragraph={{ rows: 1, width: "200px" }} />,
  createdAt: <Skeleton active title={false} paragraph={{ rows: 1, width: "120px" }} />,
  isSkeleton: true,
}));

// Exporting the skeletonData
export { skeletonData };
